<template>
    <div class="component">
        <h1>Statistiken</h1>
    </div>
</template>
<script>
export default {
    name: "Statistics"
}
</script>